<template>
  <div class="white py-4 px-4">
    <!-- <JypointCard
      v-if="!inject"
      class="mb-2"
    /> -->
    <v-layout
      align-center
      class="ma-0"
    >
      <div
        v-if="!hideTitle"
        class="title subTitle mr-4"
      >
        海快行事曆
      </div>
      <b class="title">{{ viewMonth | dateFormat('YYYY') }}年</b>
      <v-btn
        icon
        class="ma-0"
        @click="prevMonth"
      >
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <b class="title">{{ viewMonth | dateFormat('MM') }}月</b>
      <v-btn
        icon
        class="ma-0"
        @click="nextMonth"
      >
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
      <v-spacer />
      <div
        v-if="post"
        class="caption white--text px-3 py-1 mr-4"
        style="cursor: pointer;overflow: hidden;text-overflow: ellipsis;border-radius: 20px;background: #b12a31;"
        @click="
          $store.dispatch('viewPost', post.poid)
        "
      >
        {{ post.title }}
      </div>
      <div v-if="calWhsAddrid==='1591'">
        <v-layout class="caption ma-0">
          <v-spacer />
          <span
            :class="{active:calTag==='自取店'}"
            class="calTagBtn mr-4"
            @click="calTag='自取店';fetchList()"
          >
            自取店
          </span>
          <span
            :class="{active:calTag==='宅配'}"
            class="calTagBtn mr-2"
            @click="calTag='宅配';fetchList()"
          >
            宅配
          </span>
        </v-layout>
      </div>
      <div v-if="calWhsAddrid==='1592' && calEvent==='海快船期'">
        <v-layout class="caption ma-0">
          <v-spacer />
          <span
            :class="{active:calTag==='台中自取'}"
            class="calTagBtn mr-4"
            @click="calTag='台中自取';fetchList()"
          >
            台中自取
          </span>
          <span
            :class="{active:calTag==='高雄自取'}"
            class="calTagBtn mr-4"
            @click="calTag='高雄自取';fetchList()"
          >
            高雄自取
          </span>
          <span
            :class="{active:calTag==='宅配'}"
            class="calTagBtn mr-2"
            @click="calTag='宅配';fetchList()"
          >
            宅配
          </span>
        </v-layout>
      </div>
      <div v-if="calWhsAddrid==='1596' && calEvent==='海快船期'">
        <v-layout class="caption ma-0">
          <div class="red--text mr-4 mt-1">
            *義烏倉轉運到漳州倉需要1~2天
          </div>
          <v-spacer />
          <!-- brand-fence:start id=pc-introduc-se-mgb-hide-matsu-pickup brand=mgb predicate=data-driven -->
          <span
            v-if="!isMgb"
            :class="{active:calTag==='馬祖自取'}"
            class="calTagBtn mr-4"
            @click="calTag='馬祖自取';fetchList()"
          >
            馬祖自取
          </span>
          <!-- brand-fence:end id=pc-introduc-se-mgb-hide-matsu-pickup -->
          <span
            :class="{active:calTag==='宅配'}"
            class="calTagBtn mr-2"
            @click="calTag='宅配';fetchList()"
          >
            宅配
          </span>
        </v-layout>
      </div>
      <div
        v-if="jyWarehouses.length"
        style="width: 140px;"
        class="ml-4"
      >
        <v-select
          v-model="calWhsAddrid"
          :items="jyWarehouses"
          hide-details
          class="mt-0 pt-0"
          @change="fetchList"
        />
      </div>
    </v-layout>
    <div
      v-if="isEconomy"
      class="pa-2 red--text caption"
    >
      ＊經濟倉裝櫃及清關時間不穩定，行事曆僅供參考
    </div>
    <v-layout class="ma-0 py-2">
      <div style="flex: 1;">
        <v-layout
          class="text-xs-right caption ma-0"
          style="height: 30px;"
        >
          <v-flex>
            週日
          </v-flex>
          <v-flex>
            週一
          </v-flex>
          <v-flex>
            週二
          </v-flex>
          <v-flex>
            週三
          </v-flex>
          <v-flex>
            週四
          </v-flex>
          <v-flex>
            週五
          </v-flex>
          <v-flex>
            週六
          </v-flex>
        </v-layout>
        <v-layout
          wrap
          class="calendarWrap caption ma-0"
        >
          <div
            v-for="(item,i) in monthData"
            :key="i"
            :class="getItemClass(item)"
            style="width: 14.28571%"
            @click="toggleView(item)"
          >
            <div class="date mb-2">
              <b>{{ item.text }}</b>
            </div>
            <template v-if="viewDate && viewDate.shipDate">
              <v-spacer />
              <div>
                <v-layout
                  v-if="sameDay(viewDate.shipDate.calDate, item.date)"
                  class="schedule ma-0"
                >
                  <v-flex class="eventName noDot ma-0 pa-0">
                    <i
                      v-if="viewDate.shipDate.calEvent==='經濟型海快船期'"
                      class="iconfont iconchuan amber--text"
                    />
                    <i
                      v-else
                      class="iconfont iconchuan"
                      style="color: rgb(80 199 126);"
                    />
                  </v-flex>
                </v-layout>
                <div
                  v-if="sameDay(viewDate.shipDate.calJycutAt, item.date)"
                  class="catAt"
                >
                  截單
                </div>
                <div
                  v-if="sameDay(viewDate.shipDate.calCcexpAt, item.date)"
                  class="catAt"
                >
                  報關
                </div>
                <template v-if="isEconomy">
                  <div
                    v-if="sameDay(viewDate.shipDate.arriveDay, item.date)"
                    class="catAt"
                  >
                    抵達
                  </div>
                  <div
                    v-else
                  >
                    {{ getItemClass(item).economyText }}
                  </div>
                </template>
                <template v-else>
                  <div
                    v-if="sameDay(viewDate.shipDate.calCcimpAt, item.date)"
                    class="catAt"
                  >
                    清關
                  </div>
                  <div
                    v-if="sameDay(viewDate.shipDate.calDelivAt, item.date)"
                    class="catAt"
                  >
                    派件
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <div
                v-for="event in item.events"
                :key="event.calid"
                class="eventName"
              >
                {{ event.calEvent }}
              </div>
              <div
                v-if="item.shipDate?.calBrief"
                class="eventName"
              >
                {{ item.shipDate.calBrief }}
              </div>
              <v-spacer />
              <v-layout
                v-if="item.shipDate && !item.off"
                class="schedule ma-0"
              >
                <v-flex class="eventName noDot ma-0 pa-0">
                  <i
                    v-if="item.shipDate.calEvent==='經濟型海快船期'"
                    class="iconfont iconchuan amber--text"
                  />
                  <i
                    v-else
                    class="iconfont iconchuan"
                    style="color: #50c77e;"
                  />
                </v-flex>
                <!-- <div class="grey--text">
                  {{ item.shipDate.calDate | dateFormat('HH:mm') }}
                </div> -->
              </v-layout>
              <div v-else-if="item.updateShipOn">
                {{ item.updateShipOn | dateFormat('DD') }}號更新
              </div>
              <div class="weatherIcon">
                <WeaTherIcon
                  v-if="item.ccCwbtw && hasRain(item.ccCwbtw.wxLevel)"
                  :schedule="item.ccCwbtw.schedule"
                />
              </div>
            </template>
          </div>
        </v-layout>
      </div>
      <div
        class="dayDetailWrap pt-3 px-2"
      >
        <template v-if="viewDate && currViewDay">
          <div>
            {{ currViewDay.date | dateFormat('YYYY-MM-DD') }}
          </div>
          <div class="deatilDay mt-2">
            {{ currViewDay.date | dateFormat('D') }}
          </div>
          <div
            v-if="viewDate && viewDate.events"
            class="mt-2"
          >
            <div
              v-for="event in viewDate.events"
              :key="event.calid"
            >
              {{ event.calEvent }}
            </div>
          </div>
          <div
            style="border-top: 1px solid #eee;"
            class="mt-3"
          />
          <template v-if="viewDate && viewDate.shipDate">
            <div class="mt-3">
              截單時間
            </div>
            <div>
              {{ viewDate.shipDate.calJycutAt | dateFormat('MM-DD HH:mm') }}
            </div>
            <div
              v-if="viewDate.shipDate.currJySeQty && viewDate.shipDate.calJySeQty > 0"
            >
              <SeQty
                :scheduleShipment="viewDate.shipDate"
              />
            </div>
            <div class="mt-3">
              大陸報關時間
            </div>
            <div>
              {{ viewDate.shipDate.calCcexpAt | dateFormat('MM-DD') }}
            </div>
            <div class="mt-3">
              台灣清關時間
            </div>
            <div class="pt-1">
              <WeaTherIcon
                v-if="viewDate.shipDate.ccCwbtw && viewDate.shipDate.ccCwbtw.wxLevel"
                :schedule="viewDate.shipDate"
              />
              {{ viewDate.shipDate.calCcimpAt | dateFormat('MM-DD') }}
              <span v-if="viewDate.shipDate.hasHzkzq">
                ，自取
              </span>
            </div>
            <div class="mt-3">
              台灣派件時間
            </div>
            <div>
              {{ viewDate.shipDate.calDelivAt | dateFormat('MM-DD') }}
            </div>
          </template>
          <!-- <div class="scheduleDate mt-2">
          <span class="num">{{ viewDate.cutAt && !viewDate.off ?viewDate.cutAt[0]:'-' }}</span>
          <span class="num">{{ viewDate.cutAt && !viewDate.off ?viewDate.cutAt[1]:'-' }}</span>
          :
          <span class="num">{{ viewDate.cutAt && !viewDate.off ?viewDate.cutAt[3]:'-' }}</span>
          <span class="num">{{ viewDate.cutAt && !viewDate.off ?viewDate.cutAt[4]:'-' }}</span>
        </div> -->
          <div class="mt-4">
            <div
              v-if="viewDate && viewDate.events"
              class="mt-2"
            >
              <div
                v-for="event in viewDate.events"
                :key="event.calid"
              >
                {{ event.calBrief }}
              </div>
            </div>
            <!-- 特殊說明：XX當日截單時間當日截單時間當日截單時間 -->
            <!-- <div
              v-if="currViewDay?.shipDate?.calBrief"
              class="mt-2"
            >
              {{ currViewDay.shipDate.calBrief }}
            </div> -->
          </div>
        </template>
      </div>
    </v-layout>

    <template
      v-if="!inject"
    >
      <div class="title subTitle mt-4">
        海快說明
      </div>

      <v-layout class="ma-0 textWrap mt-4">
        <v-flex class="mr-2 pa-4">
          <div class="title mb-2">
            <img
              src="./images/icon_description.png"
              width="23"
              class="mr-4"
            >服務說明
          </div>
          <div class="px-4 ml-4 mt-3">
            <template v-if="isMgb">
              合包後1公斤起算，不滿10公斤需加收NT$80派件費。運費皆已包含配送費、清關費，根據不同運費方案提供包稅和不包稅的服務。配合的台灣物流為「新竹」
            </template>
            <template v-else>
              合包後5公斤起運，不足5公斤以5公斤計費 ，可使用巧拼與其他會員拼單集運。運費皆已包含配送費、清關費，根據不同運費方案提供包稅和不包稅的服務。配合的台灣物流為「新竹」
            </template>
          </div>
        </v-flex>
        <v-flex class="pa-4">
          <div class="title mb-2">
            <img
              src="./images/icon_weight.png"
              width="23"
              class="mr-4"
            >拋貨/超才費用
          </div>
          <div class="px-4 ml-4 mt-3">
            不收此項費用
          </div>
        </v-flex>
      </v-layout>

      <v-layout class="ma-0 textWrap mt-2">
        <!-- <v-flex class="mr-2 pa-4">
          <div class="title mb-2">
            <img
              src="./images/icon_prescription.png"
              width="23"
              class="mr-4">運送時效說明</div>
          <div class="px-4 ml-4 mt-3">
            寄出後<span class="black--text">2-3天抵台</span>，抵台後安排清關配送，如遇船班延誤、台灣海關查驗等會延遲<span class="black--text">1-3個工作日</span>。
          </div>
        </v-flex> -->
        <v-flex class="pa-4">
          <div class="title mb-2">
            <img
              src="./images/icon_material.png"
              width="23"
              class="mr-4"
            >體積重量限制
          </div>
          <div class="px-4 ml-4 mt-3">
            最大體積/重量限制：<br>
            1. 海快單件物品限制長寬高 180cm*180cm*長(不限)，三邊有其中兩邊超過180cm無法通過海關x光機，需要轉一般倉正式報關<template v-if="!isMgb">；漳州倉馬祖專線單件物品限制長寬高 120cm*120cm*長(不限)，三邊有其中兩邊超過120cm無法通過海關x光機，需要轉一般倉正式報關</template>；重量超過70kg 也需轉正式報關，時效慢且會產生高額雜費(新台幣3-6千)，稅金另計，總費用向您實報實銷。<br>
            2. 單件包裹單邊長度超過250公分、材積超過30才或重量超過50公斤時，物流可能會外派專車配送，若有產生專車費用時將會向您實報實銷。<br>
            3.單邊超過115cm（含）的物體皆視為<b>超長件</b><Tooltips>
              超長件下單注意事項：<br>
              1.有超長件合併包裹下單時，由於同一筆訂單會打成多個包裹，只能選擇x3申報（不包稅）<br>
              2.合併打包後的包裹如果單個集運包裹不足{{ minChargeKg }}將以{{ minChargeKg }}收費，如果超長件包裹不足{{ minChargeKg }}由於是單獨打包將以{{ minChargeKg }}收費。<br>
            </Tooltips>
            ，由於超過最大的透明袋尺寸，當合併包裹下單時會無法封口，倉庫只能將長度超過115cm的商品(無論是否細長型) 單獨打包，因此會產生多個包裹出貨。<br>
          </div>
        </v-flex>
      </v-layout>

      <div class="mt-2 pa-4 tiemTextWrap">
        <div class="title mb-2">
          <img
            src="./images/icon_prohibit.png"
            width="23"
            class="mr-4"
          >禁止運送項目
        </div>
        <div class="px-4 ml-4 mt-3">
          食品、農產品、乾燥花、地板、瓷磚、電話卡(網卡)、醫藥用品、酒、毒品、槍支、易燃易爆物、電子煙相關產品...
          <br>
          建議購物前先使用本站的
          “
          <b style="color:#ff806b">能寄嗎</b>
          <img
            src="../parcel/images/nengjima.png"
            height="22"
            class="mr-2"
            style="vertical-align: middle;"
          >
          ”
          功能查詢，國際運輸有一定風險，針對易碎品務必請賣家包裝好
        </div>
      </div>

      <div class="mt-2 pa-4 tiemTextWrap">
        <div class="title mb-2">
          <img
            src="./images/icon_time.png"
            width="23"
            class="mr-4"
          >本週計劃
        </div>
        <div class="px-4 ml-4 mt-3">
          <table>
            <tr v-if="hasZq">
              <th>日期</th>
              <th class="py-0">
                截單時間
              </th>
              <th
                class="py-0"
                width="120"
              >
                大陸報關
              </th>
              <th
                class="py-0"
                width="120"
              >
                船期
              </th>
              <th
                class="py-0"
                width="120"
              >
                清關自取
              </th>
              <th class="py-0">
                自取歷時
              </th>
              <th
                class="py-0"
                width="120"
              >
                派件
              </th>
              <th class="py-0">
                派件歷時
              </th>
            </tr>
            <tr v-else>
              <th>日期</th>
              <th>截單時間</th>
              <th width="120">
                大陸報關
              </th>
              <th width="120">
                船期
              </th>
              <th width="120">
                台灣清關
              </th>
              <th width="120">
                台灣派件
              </th>
              <th>歷時天數</th>
            </tr>
            <template
              v-for="(day,i) in cutDays"
            >
              <tr
                :key="i"
              >
                <td :style="{background: day.shipColor}">
                  {{ day.date | dateFormat('MM/DD(dd)') }}
                </td>
                <td>
                  <span v-if="day.cutSameDay">
                    {{ day.shipDate.calJycutAt | dateFormat('HH:mm') }}
                  </span>
                </td>
                <td>{{ day.shipDate.calCcexpAt | dateFormat('MM/DD(dd)') }}</td>
                <td>{{ day.shipDate.calDate | dateFormat('MM/DD(dd)') }}</td>
                <td>{{ day.shipDate.calCcimpAt | dateFormat('MM/DD(dd)') }}</td>
                <td
                  v-if="hasZq"
                >
                  <span v-if="day.shipDate.calTwAddrid && day.shipDate.calCcimpAt!='0000-00-00 00:00:00'">
                    {{ diffDay(day.date, day.shipDate.calCcimpAt) }}天
                  </span>
                  <span v-else />
                </td>
                <td>{{ day.shipDate.calDelivAt | dateFormat('MM/DD(dd)') }}</td>
                <td>{{ diffDay(day.date, day.shipDate.calDelivAt) }}天</td>
              </tr>
            </template>
          </table>
          <div class="mt-2">
            PS: 大陸平潭海關週末不上班，台灣物流週末不派件，部分地區時效會慢一天
            <div style="text-indent:2em">
              如遇不可抗因素無法按表定時間裝船會另行通知
            </div>
          </div>
        </div>
      </div>

    <!-- <div class="text-xs-center mt-4 pb-4 subheading">
      <div class="title mb-2">
        <b class="red--text">贴心提示：</b>
      </div>
      國際運輸有一定風險，針對易碎品務必請賣家包裝好
    </div> -->
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { hasRain } from '@g/utils'
import WeaTherIcon from './WeaTherIcon'
import SeQty from './components/SeQty'
import JypointCard from './components/JypointCard'
import { whsName } from '@g/filters'

export default {
  components: {
    WeaTherIcon,
    SeQty,
    JypointCard,
  },
  props: {
    inject: Boolean,
    hideTitle: Boolean,
  },
  data () {
    return {
      viewMonth: dayjs().set('date', 1),
      eventList: [],
      MMDD: dayjs().format('YYYMMDD'),
      hasRain,
      post: null,
      calWhsAddrid: this.$store.state.project.startsWith('mgb') ? '1596' : '1591',
      calEvent: this.$route.query.type === 'seq' ? '海真快船期' : '海快船期',
      calTag: '宅配',
    }
  },
  computed: {
    isMgb () {
      return this.$store.state.project.startsWith('mgb')
    },
    minChargeKg () {
      return this.isMgb ? '1kg' : '5kg'
    },
    hasZq () {
      return this.isSeq || this.calTag !== '宅配'
    },
    isEconomy () {
      return this.calWhsAddrid === '1210' || this.calWhsAddrid === '1598'
    },
    jyWarehouses () {
      const list = this.$store.state.jyWarehouses.map((item) => {
        return {
          value: item.addrid,
          text: whsName(item.addrid),
          whsInfo: item.whsInfo,
        }
      })
      if (this.isMgb) {
        return list.filter(item => ['1596', '2769'].includes(item.value))
      }
      return list.filter(item => this.$store.state.parcel.seAddrids.includes(item.value))
    },
    dayNum () {
      const dayNum = new Date(this.viewMonth.get('year'), this.viewMonth.get('month') + 1, 0)
      return dayNum.getDate()
    },
    cutDays () {
      const startDay = dayjs().add(-4, 'day')
      const list = []
      const shipColors = [
        '#93e4dd',
        '#ffdffa',
        '#f4effd',
        '#c8def1',
        '#e7cbd7',
        '#fff0c5',
        '#d4e7cd',
      ]
      for (let i = 0; i < 11; i++) {
        const currentDate = startDay.add(i, 'day')
        const eventDay = this.fullMonthData.find(item => item.shipDate && dayjs(item.shipDate.calJycutAt).format('YYYYMMDD') >= currentDate.format('YYYYMMDD'))
        if (eventDay) {
          const cutSameDay = dayjs(eventDay.shipDate.calJycutAt).format('MMDD') === currentDate.format('MMDD')

          const dayCutList = [eventDay]
          if (cutSameDay) {
            // 同一天会有多个截单日期
            this.fullMonthData.filter(item => {
              return item.shipDate &&
                      dayjs(item.shipDate.calJycutAt).format('MMDD') === dayjs(eventDay.shipDate.calJycutAt).format('MMDD') &&
                      item.shipDate.calJycutAt !== eventDay.shipDate.calJycutAt
            }).forEach(item => dayCutList.push(item))
          }
          dayCutList.forEach(dayCut => {
            list.push({
              date: currentDate,
              shipDate: dayCut.shipDate,
              cutSameDay,
              shipColor: cutSameDay ? shipColors.pop() : shipColors[shipColors.length - 1],
              d1: dayjs(dayCut.shipDate.calJycutAt).format('MMDD'),
              d2: currentDate.format('MMDD'),
            })
          })
        }
      }

      return list
    },
    fullMonthData () {
      const days = []
      const dayFront = this.viewMonth.day()
      for (let i = dayFront + 7; i > 0; i--) {
        const d = this.viewMonth.add(-i, 'day')
        days.push({
          date: d,
          MMDD: d.format('YYYMMDD'),
          text: d.format('D'),
        })
      }

      for (let i = 0; i < this.dayNum + 7; i++) {
        const d = this.viewMonth.add(i, 'day')
        days.push({
          date: d,
          MMDD: d.format('YYYMMDD'),
          text: d.format('D'),
        })
      }

      const endDate = days[days.length - 1].date

      const dayEnd = dayjs(this.viewMonth).add(1, 'month').add(-1, 'day').day()
      if (dayEnd < 6) {
        for (let i = 1; i <= 6 - dayEnd; i++) {
          const d = endDate.add(i, 'day')
          days.push({
            date: d,
            MMDD: d.format('YYYMMDD'),
            text: d.format('D'),
          })
        }
      }

      let lastShip = null
      for (let i = 0; i < this.eventList.length; i++) {
        if (this.eventList[i].calendars.length && this.eventList[i].calDate) {
          lastShip = dayjs(this.eventList[i].calDate)
        }
      }
      const currDate = dayjs().format('YYYY-MM-DD')

      let firstUpdateShipOn = null
      days.forEach(dateItem => {
        dateItem.sameDay = dateItem.date.format('YYYY-MM-DD') === currDate
        const event = this.eventList.find(item => item.calDate === dateItem.date.format('YYYY-MM-DD'))
        if (event) {
          dateItem.calendar = event.calendars[0]
          dateItem.events = event && event.restEvents.length ? event.restEvents : null
          if (dateItem.events) {
            dateItem.off = dateItem.events.find(event => event.calEvent.indexOf('停運') > -1)
            dateItem.qingguan = dateItem.events.find(event => event.calEvent.indexOf('清關') > -1)
            dateItem.haiguan = dateItem.events.find(event => event.calEvent.indexOf('海關') > -1)
            dateItem.xinzhu = dateItem.events.find(event => event.calEvent.indexOf('新竹') > -1)
            dateItem.heimao = dateItem.events.find(event => event.calEvent.indexOf('黑貓') > -1)
          }

          // 船期数据
          const calendar = {
            ...event.calendars.find(item => {
              const isSe = (item.calEvent === '海快船期' || item.calEvent === '海真快船期' || item.calEvent === '經濟型海快船期') && item.calJycutAt !== '0000-00-00 00:00:00'
              return isSe
            }),
          }
          if (calendar.calid) {
            let hasHzkzq = false
            if (calendar.calEvent === '海真快船期') {
              if (calendar.calWhsAddrid === '1592') {
                hasHzkzq = this.calTag !== '宅配' && (calendar.calTag === '台中清關' || calendar.calTag === '高雄清關' || calendar.calTag === '自取店')
              } else {
                hasHzkzq = true
              }
            }
            calendar.hasHzkzq = hasHzkzq
            dateItem.shipDate = calendar
          }
          // dateItem.shipDate = event.calendars.find(item => (item.calEvent === '海快船期' || item.calEvent === '海真快船期' || item.calEvent === '經濟型海快船期') && item.calJycutAt !== '0000-00-00 00:00:00')
          if (dateItem.shipDate) {
            dateItem.shipDate.arriveDay = dayjs(dateItem.shipDate.calDate).add(1, 'day')
            //  之後的寫 可能清派 週六週日 寫海關休息
          }
        }
        this.eventList.forEach(eventItem => {
          const cItem = eventItem.calendars.find(item => item.calCcimpAt && item.ccCwbtw && dayjs(item.calCcimpAt).format('YYYY-MM-DD') === dateItem.date.format('YYYY-MM-DD'))
          if (cItem) {
            dateItem.ccCwbtw = {
              ...cItem.ccCwbtw,
              schedule: cItem,
            }
          }
        })

        if (lastShip && dateItem.date >= lastShip) {
          const updateShipOn = dateItem.date.weekday(-1)
          if (updateShipOn > Date.now() && (!firstUpdateShipOn || updateShipOn.format('YYYY-MM-DD') === firstUpdateShipOn.format('YYYY-MM-DD'))) {
            firstUpdateShipOn = dateItem.updateShipOn = updateShipOn
          }
        }
      })

      return days
    },
    monthData () {
      const days = []
      const dayFront = this.viewMonth.day()
      for (let i = dayFront; i > 0; i--) {
        const d = this.viewMonth.add(-i, 'day')
        days.push({
          date: d,
          MMDD: d.format('YYYMMDD'),
          text: d.format('D'),
        })
      }

      for (let i = 0; i < this.dayNum; i++) {
        const d = this.viewMonth.add(i, 'day')
        days.push({
          date: d,
          MMDD: d.format('YYYMMDD'),
          text: d.format('D'),
        })
      }

      return days.map(day => this.fullMonthData.find(item => item.MMDD === day.MMDD)).filter(item => item)
    },
    currViewDay () {
      return this.monthData.find(item => item.MMDD === this.MMDD)
    },
    viewDate () {
      const viewDate = {
        ...this.nextCutDay,
      }
      if (this.currViewDay && this.currViewDay.events) {
        viewDate.events = this.currViewDay.events
      }
      return viewDate
    },
    prevCutDay () {
      // 所選日期的上一個截單日
      if (this.viewDate && this.viewDate.shipDate) {
        for (let i = this.monthData.length - 1; i >= 0; i--) {
          const item = this.monthData[i]
          if (item.shipDate && dayjs(this.viewDate.shipDate.date) > dayjs(item.shipDate.date)) {
            return item
          }
        }
      }
      return null
    },
    nextCutDay () {
      // 所選日期的下一個截單日
      if (this.currViewDay) {
        for (let i = 0; i < this.monthData.length; i++) {
          const item = this.monthData[i]
          if (item.shipDate && dayjs(this.currViewDay.date).diff(item.shipDate.calJycutDate, 'day') <= 0) {
          // if (item.shipDate && dayjs(this.currViewDay.date).diff(item.shipDate.date, 'day') <= 0) {
            return item
          }
        }
      }
      return null
    },
  },
  watch: {
    viewMonth () {
      this.MMDD = ''
      this.fetchList()
    },
    calWhsAddrid () {
      // if (this.calWhsAddrid === '1591') {
      //   this.calTag = '宅配'
      // }
      // if (this.calWhsAddrid === '1592') {
      //   this.calTag = '宅配'
      // }
      // if (this.calWhsAddrid === '3591') {
      //   this.calTag = '宅配'
      // }
      // if (this.calWhsAddrid === '1596') {
      //   this.calTag = '宅配'
      // }
      this.calTag = '宅配'
      this.fetchList()
    },
  },
  async mounted () {
    this.fetchList()
    this.post = await this.$store.dispatch('post/fetchCalendarNotice', {
      // objTable: 'calendar',
      objid: 'se',
    })
  },
  methods: {
    dayBetween (startDate, endDate, date) {
      return dayjs(startDate) < dayjs(date) && dayjs(endDate) > dayjs(date)
    },
    sameDay (d1, d2) {
      return dayjs(d1).format('YYYY-MM-DD') === dayjs(d2).format('YYYY-MM-DD')
    },
    getItemClass (item) {
      const currViewDay = this.viewDate
      const prevCutDay = this.prevCutDay
      const p = {
        active: this.MMDD === item.MMDD,
        sameDay: !currViewDay && item.sameDay,
      }
      if (currViewDay && currViewDay.shipDate) {
        const isCut = this.sameDay(currViewDay.shipDate.calJycutAt, item.date)

        let economyTime = false // 經濟倉不穩定時效
        let economyText = ''
        if (this.isEconomy) {
          if (!this.sameDay(currViewDay.shipDate.calDate, item.date) && dayjs(item.date) > dayjs(currViewDay.shipDate.calDate) && dayjs(item.date).diff(dayjs(currViewDay.shipDate.calDate), 'day') < 9) {
            economyTime = true
            if (dayjs(item.date) > dayjs(currViewDay.shipDate.calDate).add(1, 'day')) {
              economyText = '可能清派'
              if (dayjs(item.date).weekday() === 6 || dayjs(item.date).weekday() === 0) {
                economyText = '海關休息'
              }
            }
          }
        }
        return {
          ...p,
          ship: this.sameDay(currViewDay.shipDate.calDate, item.date),
          cut: isCut,
          pack: !isCut && prevCutDay && this.dayBetween(prevCutDay.shipDate.calJycutAt, currViewDay.shipDate.calJycutAt, item.date),
          export: this.sameDay(currViewDay.shipDate.calCcexpAt, item.date),
          cc: this.sameDay(currViewDay.shipDate.calCcimpAt, item.date),
          calDelivAt: this.sameDay(currViewDay.shipDate.calDelivAt, item.date),
          economyTime,
          economyText,
        }
      }
      return p
    },
    toggleView (item) {
      if (this.MMDD === item.MMDD) {
        this.MMDD = ''
      } else {
        this.MMDD = item.MMDD
      }
      //  else if (this.MMDD && this.currViewDay && this.currViewDay.shipDate) {
      //   this.MMDD = ''
      // }
    },
    diffDay (d1, d2) {
      d1 = dayjs(d1).add(-1, 'day')
      d2 = dayjs(d2).add(1, 'day')
      // return d2.diff(d1, 'week')
      return d2.diff(d1, 'day')
    },
    prevMonth () {
      this.viewMonth = dayjs(this.viewMonth).add(-1, 'month')
    },
    nextMonth () {
      this.viewMonth = dayjs(this.viewMonth).add(1, 'month')
    },
    async fetchList () {
      this.eventList = []

      let calEvent = this.calEvent
      if (this.calWhsAddrid === '1592') {
        if (this.calTag === '宅配') {
          calEvent = '海快船期'
        } else if (this.calTag === '台中自取') {
          calEvent = '海真快船期'
        } else if (this.calTag === '高雄自取') {
          calEvent = '經濟型海快船期'
        }
      } else if ((this.calWhsAddrid === '1591' || this.calWhsAddrid === '1596') && this.calEvent === '海快船期') {
        if (this.calTag === '宅配') {
          calEvent = '海快船期'
        } else {
          calEvent = '海真快船期'
        }
      }
      // 往前后多查 6 天
      const res = await this.$store.dispatch('calendar/searchSchedules', {
        calType: 'se',
        cutDateStart: dayjs(this.viewMonth).add(-10, 'day').format('YYYY-MM-DD'),
        cutDateEnd: dayjs(this.viewMonth).add(1, 'month').add(5, 'day').format('YYYY-MM-DD'),
        calWhsAddrid: this.calWhsAddrid,
        calEvent,
      })
      if (!res.data.error) {
        this.eventList = res.data.list.map((item) => {
          return {
            ...item,
            calendars: item.calendars,
          }
        })
      }
    },
  },
}
</script>
<style lang="postcss" scoped>
.subTitle {
  color: #50C77E;
  &:before {
    background: currentColor;
  }
}
.calendarWrap {
  border: 2px solid #50C77E;
  > * {
    display: flex;
    flex-direction: column;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    text-align: right;
    padding: 5px;
    min-height: 90px;
    cursor: pointer;
    position: relative;
    cursor: pointer;
    .weatherIcon {
      position: absolute;
      left: 5px;
      top: 5px;
    }
    &.active {
      border: 2px solid #FF9800;
    }
    &.sameDay {
      border: 2px solid green;
    }
    .catAt {
      text-align: left;
    }
    .eventName {
      text-align: left;
      padding-left: 3px;
      &.greenEvent {
        padding-left: 0px;
        &:before {
          background: #4caf50;
        }
      }
      &.noDot {
        &:before {
          background: none;
          width: 0;
        }
      }
      &:before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #f00;
        border-radius: 50%;
      }
    }
    .schedule {
      flex: none;
    }

    &.cut, &.pack {
      background: #f4fcf5;
    }
    &.export {
      background: #fdeaea;
    }
    &.cc {
      background: #e6f6ff;
    }
    &.calDelivAt {
      background: #ebedff;
    }
    &.economyTime {
      background: #fff8ee;
    }
  }
}
.dayDetailWrap {
  width: 120px;
  margin-top: 30px;
  background: #50C77E;
  color: #fff;
  text-align: center;
  .deatilDay {
    background: #FFC107;
    width: 60px;
    height: 60px;
    line-height: 60px;
    margin: auto;
    font-size: 30px;
  }
  .scheduleDate {
    .num {
      display: inline-block;
      width: 15px;
      height: 15px;
      line-height: 15px;
      background: #fff;
      color: #000;
      text-align: center;
    }
  }
}

.textWrap {
  > * {
    border: 2px solid #50C77E;
    flex: 1;
    .title {
      color: #50C77E;
      font-weight: bold;
      img {
        vertical-align: middle;
      }
    }
  }
}
.tiemTextWrap {
  border: 2px solid #50C77E;
  img {
    vertical-align: middle;
  }
  table {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    th,td{
      border: 1px solid #50C77E;
    }
    th {
      padding: 10px 5px;
    }
    td {
      padding: 8px 5px;
    }
  }
}
.subTitle {
  font-weight: bold;
}

.calEventToogleBtn {
  opacity: 0.5;
  padding: 2px;
  &.active {
    opacity: 1;
    border: 1px solid currentColor;
    border-radius: 3px;
  }
}
.calTagBtn {
  opacity: 0.5;
  padding: 4px 8px;
  border: 1px solid currentColor;
  border-radius: 4px;
  cursor: pointer;
  &.active {
    opacity: 1;
  }
}
</style>
